import { ChangeDetectorRef, Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@df/catalog/store/store';
import { StoreService } from '@df/catalog/store/store.service';
import { Status } from '@df/core/status';
import { Subscription } from 'rxjs';
import { SagepayCloudPaymentService } from './sagepay-cloud-payment.service';

@Directive()
export abstract class SagepayCloudPaymentComponentDef implements OnInit, OnDestroy {
    stores?: Store[];

    loadStatus = new Status();

    protected subscriptions = new Subscription();

    private _storeId?: number | null;

    protected storeService = inject(StoreService);
    protected sagepayCloudPayment = inject(SagepayCloudPaymentService);
    protected changeDetectorRef = inject(ChangeDetectorRef);

    ngOnInit() {
        this._storeId = this.sagepayCloudPayment.storeId;
        this.subscriptions.add(
            this.sagepayCloudPayment.storeIdSubject.subscribe(() => {
                this._storeId = this.sagepayCloudPayment.storeId;
                this.detectChanges();
            })
        );
        this.subscriptions.add(this.status.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.loadStatus.subscribe(() => this.detectChanges()));
        this.storeService.loadAll(this.loadStatus, 1).then(() => {
            this.stores = this.storeService.resource.getAllExisting();
            this.detectChanges();
        });
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    get storeId(): number | null {
        return this._storeId;
    }

    set storeId(id: number | null) {
        this._storeId = id;
        this.sagepayCloudPayment.changeStore(id);
    }

    get status(): Status {
        return this.sagepayCloudPayment.status;
    }

    detectChanges(): void {
        this.changeDetectorRef.detectChanges();
    }

    trackByModelId(index: number, model: Store): number {
        return model.id;
    }
}
